var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "animated fadeIn" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-6" },
        [
          _c(
            "b-card",
            {
              attrs: {
                header: "<i class='fa fa-align-justify'></i> Simple Table",
              },
            },
            [
              _c("table", { staticClass: "table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Username")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Date registered")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Role")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Status")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("Samppa Nori")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Estavan Lykos")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(
                            "\n                  Banned\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Chetan Mohamed")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Admin")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(
                            "\n                  Inactive\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Derick Maximinus")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/03/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(
                            "\n                  Pending\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Friderik Dávid")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/21")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "pagination" }, [
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Prev"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item active" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("1"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("2"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("3"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("4"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Next"),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-6" },
        [
          _c(
            "b-card",
            {
              attrs: {
                header: "<i class='fa fa-align-justify'></i> Striped Table",
              },
            },
            [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Username")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Date registered")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Role")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Status")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("Yiorgos Avraamu")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Avram Tarasios")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(
                            "\n                  Banned\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Quintin Ed")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Admin")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(
                            "\n                  Inactive\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Enéas Kwadwo")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/03/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(
                            "\n                  Pending\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Agapetus Tadeáš")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/21")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "pagination" }, [
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Prev"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item active" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("1"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("2"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("3"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("4"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Next"),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-6" },
        [
          _c(
            "b-card",
            {
              attrs: {
                header: "<i class='fa fa-align-justify'></i> Condensed Table",
              },
            },
            [
              _c("table", { staticClass: "table table-sm" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Username")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Date registered")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Role")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Status")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("Carwyn Fachtna")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Nehemiah Tatius")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(
                            "\n                  Banned\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Ebbe Gemariah")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Admin")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(
                            "\n                  Inactive\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Eustorgios Amulius")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/03/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(
                            "\n                  Pending\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Leopold Gáspár")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/21")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "pagination" }, [
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Prev"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item active" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("1"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("2"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("3"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("4"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Next"),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-6" },
        [
          _c(
            "b-card",
            {
              attrs: {
                header: "<i class='fa fa-align-justify'></i> Bordered Table",
              },
            },
            [
              _c("table", { staticClass: "table table-bordered" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Username")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Date registered")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Role")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Status")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [_vm._v("Pompeius René")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Paĉjo Jadon")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(
                            "\n                  Banned\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Micheal Mercurius")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/02/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Admin")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(
                            "\n                  Inactive\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Ganesha Dubhghall")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/03/01")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Member")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(
                            "\n                  Pending\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("Hiroto Šimun")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("2012/01/21")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Staff")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v(
                            "\n                  Active\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "pagination" }, [
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Prev"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item active" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("1"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("2"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("3"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("4"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "page-item" }, [
                  _c("a", { staticClass: "page-link", attrs: { href: "#" } }, [
                    _vm._v("Next"),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "b-card",
            {
              attrs: {
                header:
                  "<i class='fa fa-align-justify'></i> Combined All Table",
              },
            },
            [
              _c(
                "table",
                { staticClass: "table table-bordered table-striped table-sm" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Username")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Date registered")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Role")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Status")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [_vm._v("Vishnu Serghei")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("2012/01/01")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Member")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "success" } }, [
                            _vm._v(
                              "\n                  Active\n                "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Zbyněk Phoibos")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("2012/02/01")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Staff")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "danger" } }, [
                            _vm._v(
                              "\n                  Banned\n                "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Einar Randall")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("2012/02/01")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Admin")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "secondary" } }, [
                            _vm._v(
                              "\n                  Inactive\n                "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Félix Troels")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("2012/03/01")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Member")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "warning" } }, [
                            _vm._v(
                              "\n                  Pending\n                "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Aulus Agmundr")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("2012/01/21")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Staff")]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "success" } }, [
                            _vm._v(
                              "\n                  Active\n                "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("nav", [
                _c("ul", { staticClass: "pagination" }, [
                  _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      { staticClass: "page-link", attrs: { href: "#" } },
                      [_vm._v("Prev")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "page-item active" }, [
                    _c(
                      "a",
                      { staticClass: "page-link", attrs: { href: "#" } },
                      [_vm._v("1")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      { staticClass: "page-link", attrs: { href: "#" } },
                      [_vm._v("2")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      { staticClass: "page-link", attrs: { href: "#" } },
                      [_vm._v("3")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      { staticClass: "page-link", attrs: { href: "#" } },
                      [_vm._v("4")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      { staticClass: "page-link", attrs: { href: "#" } },
                      [_vm._v("Next")]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }